<button *ngIf="hasFilters"
    type="button" 
    class="btn btn--text btn--primary mright8" 
    (click)="clearFilters()">
    Clear filters
</button>

<span class="std-list-search-box workspace-object-filters__search">
    <i class="icon-search"></i>
    <input type="search" placeholder="Search" name="workspace-object-search" [(ngModel)]="filters.search" (ngModelChange)="filterChanged()" />
</span>

<mat-form-field>
    <mat-select [(value)]="filters.types" (valueChange)="filterChanged()" multiple placeholder="Type" disableOptionCentering>
        <mat-select-trigger>
            <b *ngIf="filters.types.length">{{ filters.types.length }}</b>
            {{ 'Type' | plurify: (filters.types.length || 0) }}
        </mat-select-trigger>
        <mat-option *ngFor="let type of types" [value]="type" class="workspace-object-filters__select-option">
            <i [ngClass]="[type | typeToIcon, type | typeToColor]" class="mright8"></i>
            <span>{{ type | niceConst }}</span>
        </mat-option>
    </mat-select>
</mat-form-field>

<sort-order-button class="workspace-object-filters__sort-order" [(value)]="sort.reverse" (valueChange)="sortChanged()">
</sort-order-button>

<mat-form-field>
    <mat-select [(value)]="sort.by" (valueChange)="sortChanged()" disableOptionCentering>
        <mat-option *ngFor="let sortType of sortProperties" [value]="sortType" class="workspace-object-filters__select-option">
            {{ sortType }}
        </mat-option>
    </mat-select>
</mat-form-field>

<button class="workspace-object-filters__favorite btn btn--text btn--secondary btn--select" (click)="toggleFavorites(filters)">
    <i class="icon-star" [class.active]="filters.starred"></i>
    Favorites
</button>
